import React from 'react'
import Navbar from './component/Navbar'
import Header from './Header'
const About = () => {
  return (

    
    <>
    <Header/>
      <Navbar/>
    </>
  )
}

export default About